import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames/bind';

import {
  DataBlocks,
  I18n,
  Link,
  Icon,
} from 'components';

import { formatLogin } from 'utils/formatString';

import styles from './styles.pcss';

const cx = classNames.bind(styles);

const AccountPreview = ({
  login,
  nickName,
  ssoLoginDefault,
  openAccountEditPopup,
  unlinkAccount,
  className,
  isMobile,
  isPostpaid,
  postpaidLimit,
  banLogin,
}) => {
  const isUnlinkAllowed = !!unlinkAccount;

  return (
    <DataBlocks.TableRow
      className={cx('tableRow', className)}
    >
      <DataBlocks.TableCell
        className={cx('defaultLogin', 'inlineForPhone')}
      >
        {ssoLoginDefault && <Icon name="star" />}
      </DataBlocks.TableCell>
      <DataBlocks.TableCell
        className={cx('icon', 'inlineForPhone')}
      >
        {isMobile
          ? (
            <Icon
              name="phone"
              className={cx('phoneIcon')}
            />
          )
          : (
            <Icon
              name="home"
              className={cx('homeIcon')}
            />
          )}
      </DataBlocks.TableCell>
      <DataBlocks.TableCell
        className={cx('phoneNumber', 'inlineForPhone')}
      >
        {formatLogin(login, !isMobile)}
      </DataBlocks.TableCell>
      <DataBlocks.TableCell
        title={nickName}
        className={cx('nickName')}
        colSpan={isUnlinkAllowed ? 1 : 2}
      >
        {nickName}
      </DataBlocks.TableCell>
      <DataBlocks.TableCell
        className={cx('editButton', 'inlineForPhone')}
      >
        <Link onClick={() => openAccountEditPopup({
          banLogin,
          login,
          nickName,
          ssoLoginDefault,
          isMobile,
          isPostpaid,
          postpaidLimit,
        })}
        >
          <I18n path="common.edit" />
        </Link>
      </DataBlocks.TableCell>
      {isUnlinkAllowed
      && (
        <DataBlocks.TableCell
          className={cx('unlinkButton', 'inlineForPhone')}
        >
          <Link
            onClick={() => unlinkAccount({
              login,
              isMobile,
            })}
          >
            <I18n path="settings.numberManagement.associatedAccounts.unlink" />
          </Link>
        </DataBlocks.TableCell>
      )}
    </DataBlocks.TableRow>
  );
};

AccountPreview.propTypes = {
  login: PropTypes.string,
  nickName: PropTypes.string,
  banLogin: PropTypes.string,
  ssoLoginDefault: PropTypes.bool,
  isMobile: PropTypes.bool,
  isPostpaid: PropTypes.bool,
  postpaidLimit: PropTypes.object,
  openAccountEditPopup: PropTypes.func,
  unlinkAccount: PropTypes.func,
  className: PropTypes.any,
};

export default AccountPreview;
